/**
 * Termes du tenant exposés à toutes les chaînes i18n sous forme de VARIABLES PAR
 * DÉFAUT d'interpolation : `{{school_head}}` (Doyen / Directeur d'école…).
 * i18next relit `interpolation.defaultVariables` à chaque traduction : changer le
 * terme suffit, puis on notifie les composants montés pour qu'ils se redessinent.
 */
import i18n from '../i18n/index.js';
import { isValidCurrency, symboleDevise } from '../utils/currency.js';

export const schoolHeadParDefaut = (lng = i18n.language) => (lng === 'en' ? 'Dean' : 'Doyen');
let reglage = null; // dernier `document_settings.term_school_head` du tenant

function poser() {
  const terme = reglage || schoolHeadParDefaut();
  const interpolation = i18n.options.interpolation || (i18n.options.interpolation = {});
  const vars = interpolation.defaultVariables || {};
  if (vars.school_head === terme) return false;
  interpolation.defaultVariables = { ...vars, school_head: terme };
  return true;
}

/** @param {object|null|undefined} documentSettings  `tenant.document_settings` */
export function applyTenantTerms(documentSettings) {
  reglage = documentSettings?.term_school_head || null;
  if (poser()) i18n.emit('languageChanged', i18n.language);
}

// Sans réglage du tenant, le terme par défaut suit la langue affichée.
i18n.on('languageChanged', () => { poser(); });
poser();

/**
 * Devise et ville du tenant exposées aux chaînes i18n, comme `school_head` :
 *   `{{devise}}`      le SYMBOLE de la devise du tenant (« FCFA » pour XAF, « R » pour ZAR) ;
 *   `{{tenant_city}}` sa ville, ou des points de suspension à remplir à la main quand elle est inconnue.
 * Écart T-6 du programme de supériorité : les libellés « Montant (FCFA) », « Fait à Douala, le… »
 * nommaient une devise et une ville pour tout établissement. Pour un tenant en XAF dont la ville est
 * renseignée, le texte affiché est celui d'une configuration ; pour un autre, il suit SA configuration.
 */
export const POINTS_A_REMPLIR = '.........................';
const SYMBOLE_PAR_DEFAUT = () => symboleDevise();

function fixerVariable(nom, valeur) {
  const interpolation = i18n.options.interpolation || (i18n.options.interpolation = {});
  const vars = interpolation.defaultVariables || {};
  if (vars[nom] === valeur) return false;
  interpolation.defaultVariables = { ...vars, [nom]: valeur };
  return true;
}

/** @param {{currency?: string, city?: string}} [tenant] colonnes `tenants.currency` et `tenants.city` */
export function applyTenantDefaults(tenant = {}) {
  const code = isValidCurrency(tenant?.currency) ? tenant.currency : undefined;
  const changeDevise = fixerVariable('devise', code ? symboleDevise(code) : SYMBOLE_PAR_DEFAUT());
  const changeVille = fixerVariable('tenant_city', String(tenant?.city || '').trim() || POINTS_A_REMPLIR);
  if (changeDevise || changeVille) i18n.emit('languageChanged', i18n.language);
}

applyTenantDefaults();
